import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Scuba from "./pages/Scuba";
import Footer from "./components/Footer";
import Skydive from "./pages/Skydive";
import About from "./pages/About";
import Profile from "./pages/Profile";
import MyEnquiries from "./pages/MyEnquiries";
import MyEnquiriesById from "./pages/MyEnquiriesById";
import AdminEnquiry from "./pages/AdminEnquiry";
import AdminEnquiryById from "./pages/AdminEnquiryById";
import ProtectedRedirect from "./pages/ProtectedRedirect";
import ServiceDetail from "./pages/ServiceDetail";
import TermsPage from "./pages/TermsPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CustomLinkRedirect from "./pages/CustomLinkRedirect";
import BypassRedirect from "./pages/BypassRedirect";
import { useEffect } from "react";
import { trackPageView } from "./analytics";
import FloatingWhatsAppButton from "./components/FloatingWhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import { getActive } from "./services/api";
import { useQuery } from "@tanstack/react-query";
import Trips from "./pages/Trips";
import ItineraryPage from "./pages/ItineraryPage";
import Contact from "./pages/Contact";

function App() {
  const RouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
      trackPageView(location.pathname + location.search);
    }, [location]);

    return null;
  };
  useQuery({
    queryKey: ["active"],
    queryFn: getActive,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });
  return (
    <>
      <Router>
        <div className="app-root">
          <ScrollToTop />
          <RouteTracker />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/trips" element={<Trips />} />
            <Route path="/trips/:sku" element={<ServiceDetail />} />
            <Route path="/scuba" element={<Scuba />} />
            <Route path="/scuba/:sku" element={<ServiceDetail />} />
            <Route path="/skydive" element={<Skydive />} />
            <Route path="/skydive/:sku" element={<ServiceDetail />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/my-enquiries" element={<MyEnquiries />} />
            <Route path="/my-enquiries/:enqNo/" element={<MyEnquiriesById />} />
            <Route
              path="/my-enquiries/:enqNo/:assignCode"
              element={<MyEnquiriesById />}
            />
            <Route path="/link/:kind/:enqNo/bypass" element={<BypassRedirect />} />
            <Route path="/link/:kind/:enqNo" element={<ProtectedRedirect />} />
            <Route path="/go/:code" element={<CustomLinkRedirect />} />
            <Route path="/admin/enquiries" element={<AdminEnquiry />} />
            <Route path="/admin/itinerary" element={<ItineraryPage />} />
            <Route
              path="/admin/enquiries/:enqNo"
              element={<AdminEnquiryById />}
            />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/refund-policy" element={<RefundPolicyPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>
          <FloatingWhatsAppButton />
          <Footer />
        </div>
      </Router>
    </>
  );
}

export default App;
